import { useQuery } from '@apollo/client';
import { type ReactNode } from 'react';
import { GET_USERS_FOR_SELECT } from '@api/queries/users';
import { fullName } from '@utils/stringFormatUtils';

export interface UserCellProps {
    userId: string;
}

export function UserCell({ userId }: UserCellProps): ReactNode {
    const { data } = useQuery(GET_USERS_FOR_SELECT, {
        variables: { where: { id: userId } },
        skip: !userId,
    });

    const user = data?.users.edges[0]?.node;

    return fullName(user);
}
